import { Text } from "@microbeta/ui";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useAuthContext } from "../../../../features/auth/AuthContext";
import { useAnalytics } from "../../../../shared/hooks";
import { useNavigationLinks } from "../../../hooks/useNavigationLinks";
import styles from "./sidebar.module.scss";

export const Sidebar = () => {
  const { t } = useTranslation();
  const { navLinks, isNavLinkActive } = useNavigationLinks();
  const { authState } = useAuthContext();
  const { captureEvent } = useAnalytics();

  const handleNavClick = (key: string) => {
    captureEvent("sidebar_navigation_clicked", {
      user_id: authState.userId,
      navigation_key: key,
    });
  };

  return (
    <aside className={styles.sidebar}>
      <nav className={styles.nav}>
        {navLinks.map((link) => (
          <div key={link.key}>
            {link.key === "admin" && (
              <div className={styles.navSeparator} aria-hidden="true" />
            )}
            <Link
              to={link.path}
              className={`${styles.navLink} ${
                isNavLinkActive(link) ? styles.navLinkActive : ""
              }`}
              onClick={() => handleNavClick(link.key)}
            >
              <span className={styles.navIcon}>
                {link.icon}
                {link.badge != null && link.badge > 0 && (
                  <span className={styles.navBadge}>
                    {link.badge > 99 ? "99+" : link.badge}
                  </span>
                )}
              </span>
              <Text variant="medium" className={styles.navLabel}>
                {t(link.labelKey)}
              </Text>
            </Link>
          </div>
        ))}
      </nav>
    </aside>
  );
};
